// prettier-ignore
export const { NODE_ENV, VITE_API_BASE_URL, VITE_ASSETS_BASE_URL, VITE_AUTH_BASE_URL, VITE_DEBUG } = import.meta.env;

export const API_BASE_URL = VITE_API_BASE_URL;
export const ASSETS_BASE_URL = VITE_ASSETS_BASE_URL;
export const AUTH_BASE_URL = VITE_AUTH_BASE_URL;
export const DEFAULT_XDOMAIN = "relux.com";
export const DEFAULT_REDIRECT = `https://${DEFAULT_XDOMAIN}`;
export const DEBUG = VITE_DEBUG?.toLowerCase().trim() === "true";
export const POLICY_PAGE_URL = `https://relux.com/terms-of-service/gdpr-and-cookies`;
export const TERMS_PAGE_URL = `https://relux.com/termsofservice`;